export default {
    nav: {
        ReserveGift: 'Pre-register for Gifts',
        FollowFbRaffle: 'Follow FB for Lucky Draw',
        CharacterIntroduction: 'Character Introduction',
        Gameplay: 'Gameplay Introduction',
        AttentionFB: 'Follow Official FB',
        DownloadGift: 'Download for Gifts',
    },
    first: {
        ShopReserve: 'Pre-register for',
        ShopDown: 'Download for',
        PhoneReserve: 'Get SR Hero by Mobile Registration',
        PhoneDown: 'Download from the Store to get  SR Hero',
        Reserve: 'Pre-register',
        Down: 'Download',
        PraiseAward: 'Like our FB page for gifts',
        PraiseGift: 'Like our FB page for gifts',
    },
    reach: {
        NumberOfPeople: 'Pre-registrations',
        Achieved: 'Achieved',
        NotAchieved: 'Not-achieved',
        Unit: 'k',
        ServiceReward: 'Server-wide rewards for pre-registration goal',
        SlimageAwards: 'Get your share of the Grand Prize',
    },
    other: {
        GameIntroduction: 'Game Introduction',
        CommunityInformation: 'Community Info',
        MoreGift: 'Like our FB page for gifts',
        PleaseEnter:'Enter correct mobile number',
        Expect:"Stay tuned for more",
        restrict:"Please do not register frequently",
    },
    side: {
        ReservationNow: 'Pre-register for 2024 Draws',
        FollowFbRaffle: 'Follow official FB for lucky draw',
        Down: 'Download for 2024 Draws'
    },
    popups: {
        LimitedTime: 'Act fast: Pre-register within 30s for a 2024 draw!',
        AddReserve: 'Visit store for extra 2024 draws with pre-registration',
        Get: 'Congratulations on receiving pre-registration reward!',
        Code: 'Giftcode:',
        Congratulations: 'Congratulations!',
        CompleteStoreAppointment: 'Store pre-register done',
        FbCommunity: 'Like our FB page',
        GetGoodGift: 'Receive additional goodies',
        Over: 'Pre-registration event ended',
        PhoneReserveSuccess: 'Successfully pre-registered',
        AddDown: 'Download in stores for additional 2024 draws'
    }
}
